import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {
  BookResult
} from 'src/app/models/api_models/book';
import {
  BookService
} from 'src/app/api/book.service';
import {
  MatDialog
} from '@angular/material/dialog';
import {  MatDatepickerInputEvent} from "@angular/material/datepicker";
import {
  BookExtendConfirmDialogComponent,
  ExtendConfimData
} from '../book-extend-confirm-dialog/book-extend-confirm-dialog.component';
import { resource } from 'selenium-webdriver/http';

@Component({
  selector: 'app-book-extend-form',
  templateUrl: './book-extend-form.component.html',
  styleUrls: ['./book-extend-form.component.scss']
})
export class BookExtendFormComponent implements OnInit {


  checkCurrent = false;

  private _start : Date = null;
  get start() : Date {return this._start;}
  set start(start : Date) {this._start = start;}
  

  private _end  : Date = null;
  get end() : Date {return this._end;}
  set end(end : Date) {this._end = end;}


  private _hour: string = null;
  get hour() : string { return this._hour;}
  set hour(hour : string) {this._hour = hour;}


  private _min: string = null;
  get min() : string {return this._min;}
  set min(min : string) {this._min = min;}



  private _book: BookResult = null;
  get book(): BookResult {
    return this._book;
  }
  @Input()

  set book(book: BookResult) {
    this._book = book;
    if (this._book !== null) {
      this._start = new Date(this._book.startdate);
      this._end = new Date(this._book.enddate);
      this._start.setTime(this._start.getTime() - 1000 * 60 * 60 * 2);
      this._end.setTime(this._end.getTime() - 1000 * 60 * 60 * 2);

      this._hour = this._end.getHours().toString();
      this._min = this._end.getMinutes().toString();
      // console.log(this._hour);

    }
  }

  @Output()
  onBookChange = new EventEmitter < number > ();




   //modification date
  updateDate(type: string, event: MatDatepickerInputEvent < string > ) {
    console.log(event.value);
    this._end = new Date(event.value);
    this.checkCurrent = true
  }

  //modification heure
  updateHour(type: string, event) {
    this._end.setHours(event.value);
    this._hour = event.value.toString();
    this.checkCurrent = true
  }

  //modification minute
  updateMin(type: string, event) {
    this._end.setMinutes(event.value);
    this._min = event.value.toString();
    this.checkCurrent = true
  }


  public openConfirm() {
    if (this._end.getTime() > this._start.getTime()) {
      let oldEnd = new Date(this._book.enddate);
      oldEnd.setTime(oldEnd.getTime() - 1000 * 60 * 60 * 2);
      const dialogRef =  this.dialog.open(BookExtendConfirmDialogComponent, {
        data: new ExtendConfimData(this._book.id, this._start, this._end, oldEnd),
      });
      dialogRef.afterClosed().subscribe(
        () => {
          location.reload()
        }
      );
    }
  }


  constructor(private bookService: BookService, public dialog: MatDialog) {

  }

  ngOnInit() {}

}
